import { render, staticRenderFns } from "./Paso3.vue?vue&type=template&id=3dbf10e6&lang=pug&"
import script from "./Paso3.vue?vue&type=script&lang=js&"
export * from "./Paso3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports